import { StoryEditorView } from './story-editor/StoryEditorView'
import { useStoryEditor } from './story-editor/useStoryEditor'

function StoryEditor(props) {
  return <StoryEditorView {...useStoryEditor(props)} />
}

export default StoryEditor
